module.exports = __webpack_public_path__ + "static/media/pixel-mine.3685083b.mp3";